module.exports = __webpack_public_path__ + "media/images/savor_logo_white-b8610fe6c35471d0a4493185f6cfd5f3.png";